import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=1c064a0a&"
import script from "./Publish.vue?vue&type=script&lang=js&"
export * from "./Publish.vue?vue&type=script&lang=js&"
import style0 from "./Publish.vue?vue&type=style&index=0&id=1c064a0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports